export class ProdutoAgregado {
    cdProduto: string;
    nmProduto: string;
    nuContrato: string;
    dtContratacao: string;
    dtContratacaoFormatada: string;
    vrMensal: number;
    vrMensalFormatado: string;
    dsDescricao: string;
    cdStatus: string;
    dsStatus: string;
    solicitado?: boolean;

    constructor() {}
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/produto-agregado.ts